import "@babel/polyfill";
import "array-flat-polyfill";
import Vue from "vue";
import Swiper from "swiper";
import "swiper/swiper.min.css";
import objectFitImages from "object-fit-images";
import store from "./store";
import * as components from "./components";
import "./style/main.scss";

Vue.config.devtools = true;

/* eslint-disable */
for (let [key, value] of Object.entries(components)) {
  Vue.component(key, value);
}

new Vue({
  el: "#app",
  store
});

new Swiper('.swiper-container', {
  pagination: {
    el: '.slider__nav__pagination',
    type: 'fraction',
    renderFraction: (currentClass, totalClass) => {
      let current = '<span class="' + currentClass + '"></span>';
      let total = '<span class="' + totalClass + '"></span>';
      return current + ' von ' + total;
    }
  },
  navigation: {
    nextEl: '.slider__nav__next',
    prevEl: '.slider__nav__prev',
  }
});

objectFitImages('img', { watchMQ: true });
